import React, { useState, useEffect } from 'react';
import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';

const AdminApp = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [adminInfo, setAdminInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuthStatus();
  }, []);

  const checkAuthStatus = () => {
    const token = localStorage.getItem('adminToken');
    const storedAdminInfo = localStorage.getItem('adminInfo');

    if (token && storedAdminInfo) {
      try {
        const admin = JSON.parse(storedAdminInfo);
        setAdminInfo(admin);
        setIsAuthenticated(true);
      } catch (error) {
        console.error('Error parsing admin info:', error);
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminInfo');
      }
    }
    setLoading(false);
  };

  const handleLoginSuccess = (admin, token) => {
    setAdminInfo(admin);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    setAdminInfo(null);
    setIsAuthenticated(false);
  };

  if (loading) {
    return (
      <div className="admin-app">
        <div className="loading-overlay">
          <div className="loading-modal">
            <div className="spinner"></div>
            <span>Loading admin portal...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-app">
      {isAuthenticated ? (
        <AdminDashboard 
          adminInfo={adminInfo} 
          onLogout={handleLogout} 
        />
      ) : (
        <AdminLogin onLoginSuccess={handleLoginSuccess} />
      )}
    </div>
  );
};

export default AdminApp; 